export const ORDER_STATUS_CREATED = 1;
export const ORDER_STATUS_ACCEPTED = 2;
export const ORDER_STATUS_PREPARING = 3;
export const ORDER_STATUS_PARTLY_DONE = 4;
export const ORDER_STATUS_DONE = 5;
export const ORDER_STATUS_CANCELED = 6;
export const ORDER_STATUS_LIST = [
    ORDER_STATUS_CREATED,
    ORDER_STATUS_ACCEPTED,
    ORDER_STATUS_PREPARING,
    ORDER_STATUS_PARTLY_DONE,
    ORDER_STATUS_DONE,
    ORDER_STATUS_CANCELED
];
export const TO_DISPENSE_ORDER_STATUS_LIST = [ORDER_STATUS_ACCEPTED, ORDER_STATUS_PREPARING, ORDER_STATUS_PARTLY_DONE];
export const HISTORICAL_ORDER_STATUS_LIST = [ORDER_STATUS_DONE];
export const MY_ORDER_STATUS_LIST = [
    ORDER_STATUS_CREATED,
    ORDER_STATUS_ACCEPTED,
    ORDER_STATUS_PREPARING,
    ORDER_STATUS_PARTLY_DONE,
    ORDER_STATUS_DONE,
    ORDER_STATUS_CANCELED
];
